/**
 * Integration Logos Module
 *
 * This module provides official brand logos for integrations.
 * All logos are hosted on Cloudflare R2 CDN for optimal performance.
 *
 * CDN Base URL: https://pub-e28919aaaff748329edd36bd75e71935.r2.dev/logos/
 */

const CDN_BASE = 'https://pub-e28919aaaff748329edd36bd75e71935.r2.dev/logos';

export const integrationLogos = {
    okta: {
        src: `${CDN_BASE}/okta.svg`,
        alt: 'Okta logo',
    },
    'entra-id': {
        src: `${CDN_BASE}/entra-id.svg`,
        alt: 'Microsoft Entra ID logo',
    },
    'google-workspace': {
        src: `${CDN_BASE}/google-workspace.svg`,
        alt: 'Google Workspace logo',
    },
    bamboohr: {
        src: `${CDN_BASE}/bamboohr.svg`,
        alt: 'BambooHR logo',
    },
    workday: {
        src: `${CDN_BASE}/workday.svg`,
        alt: 'Workday logo',
    },
    intune: {
        src: `${CDN_BASE}/intune.svg`,
        alt: 'Microsoft Intune logo',
    },
    jamf: {
        src: `${CDN_BASE}/jamf.svg`,
        alt: 'Jamf Pro logo',
    },
    servicenow: {
        src: `${CDN_BASE}/servicenow.svg`,
        alt: 'ServiceNow logo',
    },
    'jira-sm': {
        src: `${CDN_BASE}/jira-sm.svg`,
        alt: 'Jira Service Management logo',
    },
    salesforce: {
        src: `${CDN_BASE}/salesforce.svg`,
        alt: 'Salesforce logo',
    },
    slack: {
        src: `${CDN_BASE}/slack.svg`,
        alt: 'Slack logo',
    },
    github: {
        src: `${CDN_BASE}/github.svg`,
        alt: 'GitHub logo',
    },
    zoom: {
        src: `${CDN_BASE}/zoom.svg`,
        alt: 'Zoom logo',
    },
    crowdstrike: {
        src: 'https://upload.wikimedia.org/wikipedia/commons/4/4f/CrowdStrike_logo.svg',
        alt: 'CrowdStrike logo',
    },
    aws: {
        src: `${CDN_BASE}/aws.svg`,
        alt: 'Amazon Web Services logo',
    },
    azure: {
        src: `${CDN_BASE}/azure.svg`,
        alt: 'Microsoft Azure logo',
    },
    coupa: {
        src: 'https://upload.wikimedia.org/wikipedia/commons/4/46/Coupa_logo.svg',
        alt: 'Coupa logo',
    },
    notion: {
        src: `${CDN_BASE}/notion.svg`,
        alt: 'Notion logo',
    },
    figma: {
        src: `${CDN_BASE}/figma.svg`,
        alt: 'Figma logo',
    },
    datadog: {
        src: `${CDN_BASE}/datadog.svg`,
        alt: 'Datadog logo',
    },
    gcp: {
        src: `${CDN_BASE}/gcp.svg`,
        alt: 'Google Cloud Platform logo',
    },
};

/**
 * Get logo information for an integration by ID.
 * @param {string} id
 * @returns {{src: string, alt: string} | null}
 */
export function getLogoByIntegrationId(id) {
    if (id in integrationLogos) {
        return integrationLogos[id];
    }
    return null;
}

/**
 * Get all integration logos.
 * @returns {Object}
 */
export function getAllLogos() {
    return integrationLogos;
}

/**
 * Get all integration IDs.
 * @returns {string[]}
 */
export function getIntegrationIds() {
    return Object.keys(integrationLogos);
}
